export const useStatusStyles = ()=>({
        icon: {
            flexShrink: 0
        }
    });

//# sourceMappingURL=status.styles.js.map